import React from 'react'

import { ImageWrap, Text } from '@hhgtech/hhg-components/components'

import { getHelloSitesUrl } from 'api/utils/paths'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { assetImagePath } from 'interfaces/constants'
import { CategoryApi } from 'interfaces/types'

import { StyledCategory } from './index.styled'

export const _Category = ({ category }: { category: CategoryApi }) => {
  const { locale } = useRouterExtend()
  return (
    <StyledCategory
      key={category.term_id}
      href={category.permalink}
      className="pointer-event-child-none"
      data-event-category="Health Tool"
      data-event-action="Category Click"
      data-event-label={`${getHelloSitesUrl(locale)}${category.permalink}`}
    >
      <div className="category-image">
        <ImageWrap
          src={category.icon || `${assetImagePath}/default-image.jpg`}
          alt=""
        />
      </div>
      <Text size="p2" style={{ textTransform: 'capitalize' }}>
        {category.name}
      </Text>
    </StyledCategory>
  )
}

export const Category = React.memo(_Category)
